'use client';

import { Navigate, useParams } from 'react-router-dom';
import WorkshopGroupClient from './WorkshopGroupClient';
import { workshopByGroupId } from '@/data/workshopGroups';

export default function BPFWorkshopGroupPage() {
  const { groupId } = useParams();
  if (!groupId) return <Navigate to="/Qiaodong/BPF/workshop" replace />;
  const groupData = workshopByGroupId[groupId];
  if (!groupData) return <Navigate to="/Qiaodong/BPF/workshop" replace />;
  return <WorkshopGroupClient groupData={groupData} groupId={groupId} />;
}
